import { findBy } from '@/store/common/getters';
export default {
  findBy,
};
